module.exports = __webpack_public_path__ + "static/img/floor.6cdeaf68.png";